// extracted by mini-css-extract-plugin
export default {"cardheader":"styles_cardheader__mnAvf"};